export default import.meta.ROLLDOWN_FILE_URL_X8CmtBmL2gY$8v_rI8yeEQ